import '@css/menu/index.css';
import { createApp, h } from 'vue';
import App from '@menu/App.vue';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

import 'scroll-behavior-polyfill';

import { plugin as VueTippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';

import isStandalone from '@/menu/Utils/isStandalone';
import ClickOutside from '@/directives/ClickOutside';
import PreventBodyScroll from '@menu/Directives/PreventBodyScroll';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import setUserOrigin from '@/utils/setUserOrigin';
import { createPinia } from 'pinia';
import getSharedData from '@menu/Utils/getSharedData';
import storeMenuVisit from '@/menu/Utils/storeMenuVisit';
import { router } from '@/menu/Router';
import { setupHtmlLangDirSync } from '@/menu/Utils/i18n';
import initMenuUpdateListener from '@/menu/Utils/initMenuUpdateListener';
import initHeightSync from '@/menu/Utils/initHeightSync';
import storeTableParamInSessionStorage from '@/menu/Utils/storeTableParamInSessionStorage';
import registerMenuServiceWorker from '@/menu/Utils/registerMenuServiceWorker';

initHeightSync();
storeTableParamInSessionStorage();

// Register SW only in standalone mode
if (isStandalone() && !getSharedData().isOrderMode) {
  void registerMenuServiceWorker();
}

Bugsnag.start({
  apiKey: getSharedData().global.keys.bugsnag,
  plugins: [new BugsnagPluginVue()],
});

setupHtmlLangDirSync();
initMenuUpdateListener();
storeMenuVisit();

const app = createApp({
  render: () => h(App),
});

app.use(createPinia());
const bugsnagVue = Bugsnag.getPlugin('vue');
bugsnagVue && app.use(bugsnagVue);
app.use(VueTippy, { defaultProps: { placement: 'top' } });
app.use(Toast, {
  transition: 'Vue-Toastification__fade',
  timeout: 2000,
});
app.use(router);
app.directive('click-outside', ClickOutside);
app.directive('prevent-body-scroll', PreventBodyScroll);
app.mount('#app');

setUserOrigin();
